<template>
  <div class="operation-item border rounded">
    <i class="fas fa-chevron-circle-right align-middle" style="font-size: x-large; float: right; line-height: 100px;"></i>
    <div style="margin-right: 80px;" class="clearfix">
      <img style="float: left; margin-right: 10px; max-width: 100px; max-height: 100px;" :src="'/laskuri/api/operation/' + operation.id + '/preview?d=' + new Date().getTime()" />
      <div class="media-body">
        <h5 class="mt-0">{{ operation.name }}</h5>
        {{ operation.description }}
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['operation']
  }
</script>

<style scoped>
  .operation-item {
    margin-bottom: 10px;
    padding: 10px;
    cursor: pointer;
    background-color: white;
  }
  .operation-item:hover {
    background-color: #eee;
  }
</style>



// WEBPACK FOOTER //
// src/components/OperationListItem.vue